// FormContext.js
import { createContext, useContext, useRef, useState } from "react";

// export const FormContext = createContext(null);

// export const FormProvider = ({ children }) => {
//   const [formData, setFormData] = useState({});
//   const [companyDetails, setCompanyDetails] = useState(null);

//   const updateFormData = (newData) => {
//     setFormData((prev) => ({ ...prev, ...newData }));
//   };

//   console.log(companyDetails);
//   return (
//     <FormContext.Provider
//       value={{ formData, updateFormData, companyDetails, setCompanyDetails }}
//     >
//       {children}
//     </FormContext.Provider>
//   );
// };

// export const useFormContext = () => useContext(FormContext);

export const FormContext = createContext(null);

export const FormProvider = ({ children }) => {
  const [signUpDetails, setSignUpDetails] = useState({});
  return (
    <FormContext.Provider
      value={{
        signUpDetails,
        setSignUpDetails,
      }}
    >
      {children}
    </FormContext.Provider>
  );
};
